import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Award, ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';
import './TrainingPages.css';

const POLLEN_BEE_IMG = "https://customer-assets.emergentagent.com/job_bee-booking/artifacts/k8zgjyqb_Pollen%20-%20bHyyve%20Mascot.png";

const Certifications = () => {
  const navigate = useNavigate();

  return (
    <div className="training-page">
      {/* Banner */}
      <div className="training-banner">
        <div className="banner-content">
          <h1>Certifications</h1>
          <p>Earn professional certifications to boost your credibility</p>
        </div>
        <img src={POLLEN_BEE_IMG} alt="Pollen" className="banner-bee" />
      </div>

      {/* Empty State */}
      <div className="empty-state">
        <div className="empty-icon">
          <Award size={64} />
        </div>
        <h2>Certifications Coming Soon</h2>
        <p>Professional certification programs are being developed for your business category. Check back soon!</p>
        <Button 
          className="back-btn"
          onClick={() => navigate('/yourhyyve')}
        >
          <ArrowLeft size={18} />
          Back to Dashboard
        </Button>
      </div>
    </div>
  );
};

export default Certifications;
